import React from 'react';
import { Link } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { getDeviceName, setQualityFlag, setMuteFlag } from './utils'
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import store from 'store';

export default class Pair extends React.Component {

  constructor() {
    super();
    this.state = {
      call: true
    }
  }

  componentDidMount() {
    this.interval = setInterval(() => this.login(this), 1000);
    var back = this.refs.back;
    back.focus();
  }

  login(that) {
    bdReq.get(`/devices/${store.get('bd-android-app__device-id')}`)
      .then((data) => {
        if (data.success) {
          setMuteFlag(data.body.device.mute);
          setQualityFlag(data.body.device.highQuality);
          store.set('device-name', data.body.device.name);
          store.set('device-id', data.body.device.id);
          var emailId = data.body.device._embedded.user.email;
          const userId = data.body.device._embedded.user.id;
          let { artist, ...y } = data.body.device._embedded.user;
          store.remove('auth__user');
          store.set('auth__user', y);
          bdReq.post('/emailLogin', { emailId })
            .then((data) => {
              if (data.success) {
                bdAuth._storeToken(data.body);
                bdReq.get(`/users/${userId}/subscriptions`)
                  .then((response) => {
                    if (response.status != 200) {
                      clearInterval(this.interval);
                      that.props.history.push('/notice/1');
                      store.remove('subscription');
                      store.set('subscription', "no");
                    }
                    else {
                      clearInterval(this.interval);
                      that.props.history.push('/Home');
                      store.remove('subscription');
                      store.set('subscription', "yes");
                      store.remove('description');
                      store.set('description', response.body.plan.description);
                    }
                  })
                  .catch(err => { });
              }
            })
            .catch(err => { });
        }
      })
      .catch(err => { });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <section className="join">
        <video className="join__video" src="https://assets.blackdove.com/videos/simon_christen___golden_gate_bridge.mp4" autoPlay loop poster="data:image/gif,AAAA"></video>
        <div className="join__wrapper">
          <div className="join__wrapper__container">
            <h3 className="join__wrapper__container__title-pair h--spacing-sm">Pair</h3>
            <h5 className="join__wrapper__container__subtitle-pair h--normalize-weight ">
              Scan the QR-code on the My Devices page within the Blackdove mobile<br />app to pair this device to your account and automatically log-in
            </h5>
            <div className="row row--push-btm-xs">
              <div className="col-12">
                {/* show qr code here */}
                <QRCode
                  value={getDeviceName()}
                  size="210"
                  renderAs="svg"
                  className="qrCode"
                />
              </div>
            </div>
          </div>

          <div className="join__wrapper__footer">
            <div className="row" style={{ padding: '0 1.8em' }}>
              <div className="col-4">
                <div ref="back" tabIndex="6" className="btn btn--round btn--dark pull-left pairBack" style={{ padding: '0.6em 1.8em', fontSize: '1.3em' }} onClick={() => this.props.history.push('/freemium')}><span className="ion-chevron-left arrowBack"> </span> Back</div>
              </div>
              <div className="col-4">
                <img className="join__wrapper__footer__logo" style={{ height: '70%', width: '150px' }} src="https://assets.blackdove.com/images/bd_logo_horizontal_alternate.svg" />
              </div>
              <div className="col-4">
                <div style={{ textAlign: 'right', marginTop: '4px' }}>
                  <h6 className="h--no-spacing" style={{ fontSize: '0.8em' }}>Golden Gate Twilight</h6>
                  <small>Simon Christen</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}